{
    "tools": {
        "VisualGrid": {
            "definitions": {
                "UnitSize": {
                    "type": "object",
                    "properties": {
                        "value": {
                            "type": "number"
                        },
                        "type": {
                            "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                            ]
                        }
                    },
                    "required": [
                        "value",
                        "type"
                    ],
                    "isTopLevelDataNode": false
                }
            },
            "type": "object",
            "required": [
                "mode",
                "isActive",
                "isVisible",
                "grid",
                "square",
                "column"
            ],
            "properties": {
                "mode": {
                    "type": "string",
                    "enum": ["grid", "column", "square"]
                },
                "isActive": {
                    "type": "boolean"
                },
                "isVisible": {
                    "type": "boolean"
                },
                "grid": {
                    "type": "object",
                    "required": ["size", "color"],
                    "properties": {
                        "size": {
                            "$ref": "#/definitions/UnitSize"
                        },
                        "color": {
                            "type": "string"
                        }
                    }
                },
                "square": {
                    "type": "object",
                    "required": ["columns", "color", "marginHorizontal", "marginVertical", "gapHorizontal", "gapVertical", "size"],
                    "properties": {
                        "columns": {
                            "type": "number"
                        },
                        "color": {
                            "type": "string"
                        },
                        "marginHorizontal": {
                            "$ref": "#/definitions/UnitSize"
                        },
                        "marginVertical": {
                            "$ref": "#/definitions/UnitSize"
                        },
                        "gapHorizontal": {
                            "$ref": "#/definitions/UnitSize"
                        },
                        "gapVertical": {
                            "$ref": "#/definitions/UnitSize"
                        },
                        "size": {
                            "$ref": "#/definitions/UnitSize"
                        }
                    }
                },
                "column": {
                    "type": "object",
                    "required": ["columns", "color", "marginHorizontal", "marginVertical", "gapHorizontal", "gapVertical", "size"],
                    "properties": {
                        "columns": {
                            "type": "number"
                        },
                        "color": {
                            "type": "string"
                        },
                        "marginHorizontal": {
                            "$ref": "#/definitions/UnitSize"
                        },
                        "marginVertical": {
                            "$ref": "#/definitions/UnitSize"
                        },
                        "gapHorizontal": {
                            "$ref": "#/definitions/UnitSize"
                        },
                        "gapVertical": {
                            "$ref": "#/definitions/UnitSize"
                        },
                        "size": {
                            "$ref": "#/definitions/UnitSize"
                        }
                    }
                }
            },
            "isTopLevelDataNode": true,
            "additionalProperties": false
        }
    }
}
